import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportFile = (displayItemlist, fieldsToExport) => {
  if (!displayItemlist || !displayItemlist.length) {
    return alert("No data to export.");
  }

  // Rows
  const data = displayItemlist.map((row) => {
    const newRow = {};
    fieldsToExport.forEach((field) => {
      newRow[field.label] = row[field.key] ?? "";
    });
    return newRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);

  // column widths (based on max string length in each column)
  const colWidths = fieldsToExport.map((field) => {
    const maxLength = Math.max(
      field.label.length,
      ...data.map((row) => row[field.label]?.toString().length || 0)
    );
    return { wch: maxLength + 5 }; // +5 for spacing
  });
  worksheet["!cols"] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Items");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(blob, "items_export.xlsx");
};

export const handleTriggerImport = (fileInputRef) => {
  fileInputRef.current.click();
};

export const handleImportFile = (file) => {
  const reader = new FileReader();

  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];

    const jsonData = XLSX.utils.sheet_to_json(worksheet);
    console.log("Imported data:", jsonData);

    // Send jsonData to your backend or state
  };

  reader.readAsArrayBuffer(file);
};
